export default __webpack_public_path__ + "static/media/ISR 2024 Participant Declaration Form.2ea723af.pdf";